import { FolderIcon, UsersIcon } from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * Users & Organizations Navigation Section
 */
export const usersOrganizationsSections: NavigationSectionConfig[] = [
  {
    id: 'users-orgs-section',
    label: 'Users & Organisations',
    topNavId: 'users-organizations',
    items: [
      {
        id: 'organizations',
        label: 'Organisations',
        path: '/admin/organizations',
        icon: <FolderIcon size={18} />,
        permissions: ['nav:organizations']
      },
      {
        id: 'users',
        label: 'Users',
        path: '/admin/users',
        icon: <UsersIcon size={18} />,
        permissions: ['nav:users']
      }
    ]
  }
];

